@if (condition) {
  <div class="string1-condition-editor" [formGroup]="detailsFormGroup">
    <div class="row">
      <mat-form-field class="flex-grow" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.string1"></sc-dictionary-label>
        </mat-label>
        <input matInput formControlName="string1" name="string1" maxlength="255"
          [maxlength]="255">
        </mat-form-field>
      </div>
    </div>
  }
